/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Meta_TitleInputs */

const en_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | The AI-Powered Creator Marketplace`)
};

const es_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | El mercado para creadores impulsado por IA`)
};

const fr_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | La marketplace pour créateurs propulsée par l'IA`)
};

const de_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Der KI-gestützte Marktplatz für Creator`)
};

const ja_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | AIを活用したクリエイターマーケットプレイス`)
};

const zh_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | AI 驱动的创作者市场`)
};

const ar_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | سوق المبدعين المدعوم بالذكاء الاصطناعي`)
};

const id_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Marketplace Berbasis AI`)
};

const it_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Il Marketplace per Creatori basato sull'IA`)
};

const ru_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | Маркетплейс для авторов на базе ИИ`)
};

const pt_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | O Marketplace para Criadores com IA`)
};

const ko_home_meta_title = /** @type {(inputs: Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect | AI 기반 크리에이터 마켓플레이스`)
};

/**
* | output |
* | --- |
* | "Shoot Share Connect \| The AI-Powered Creator Marketplace" |
*
* @param {Home_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_meta_title = /** @type {((inputs?: Home_Meta_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Meta_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_meta_title(inputs)
	if (locale === "es") return es_home_meta_title(inputs)
	if (locale === "fr") return fr_home_meta_title(inputs)
	if (locale === "de") return de_home_meta_title(inputs)
	if (locale === "ja") return ja_home_meta_title(inputs)
	if (locale === "zh") return zh_home_meta_title(inputs)
	if (locale === "ar") return ar_home_meta_title(inputs)
	if (locale === "id") return id_home_meta_title(inputs)
	if (locale === "it") return it_home_meta_title(inputs)
	if (locale === "ru") return ru_home_meta_title(inputs)
	if (locale === "pt") return pt_home_meta_title(inputs)
	return ko_home_meta_title(inputs)
});